<template>
<div id="ValidaRca" class="container small">
  <span> <img id="logo" src="../../assets/logo_kibon.png" class="w-75" alt="Logo"> </span>
  <br/>
  <br/>
  <form id="equipamentoForm" v-on:submit.prevent="logar">
    <div class="form-group">
      <label for="exampleInputEmail1">Código RCA</label>
      <input type="number" v-model="codigo" class="form-control" id="exampleInputEmail1" aria-describedby="codigoHelp" placeholder="Código RCA">
    </div>
    <div class="form-group">
      <label for="exampleInputPassword1">Senha</label>
      <input type="password" v-model="senha" class="form-control" id="exampleInputPassword1" placeholder="Senha">
    </div>
    <button type="submit" class="btn btn-primary">Enviar</button>   
  </form>
</div>
</template>
<script>
const fb = require('../../config/db.js')

export default {
  name: 'ValidaRca',
  data(){
    return {
      codigo: '',
      senha: '',
      rca: {
        'codusur': '',
        'nome': ''
      }
    }
  },
  beforeCreate: function () {
    if (this.$session.exists()) {
      this.$router.push('/atualiza')
    }
  },
  methods:{
    logar(){
      if (this.senha != '2019'){
        alert('Senha inválida');
        this.senha = '';
        return;
      }
      fb.Rcas.where('codusur', '==', this.codigo).get().then(querySnapshot =>{
        querySnapshot.forEach((doc)=>{
          this.rca = doc.data();
          this.rca.id = doc.id;
          this.$session.start();
          this.$session.set('rca', this.rca.codusur);
          this.$router.push('/atualiza');
        });
      });

    }
  }
}
</script>
<style scoped>

</style>
